import axios from 'axios'
import { MessageBox } from 'element-ui';

const isNewVersion = async (name) => {
    let url = `//${window.location.host}/version.json?t=${new Date().getTime()}`;
    let res = await axios.get(url);
    if (res.status === 200) {
        let vueVersion = res.data.version,
            localVueVersion = localStorage.getItem('vueVersion');
        /*
        * 判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
        * 1.判断是否有存储版本号
        * 2.判断旧版本号跟新版本号是否一致   
        */
        if (localVueVersion && localVueVersion != vueVersion) {
            localStorage.setItem('vueVersion', vueVersion);
            // 初次加載首頁刷新不彈窗
            if(name==="home")
            window.location.reload();
            else{
                /*
                MessageBox.alert('檢測到應用已更新,頁面將刷新', '系統提示', {
                    confirmButtonText: '確定',
                    showClose: false,
                    callback: action => {window.location.reload();
                    }
                });
                */
                window.location.reload();
            }
            } else {
                localStorage.setItem('vueVersion', vueVersion);
            }
    }
    return res.data.version
}

export default {
    isNewVersion
}